import axios from "../customize_axios";
export const addCategory = async (token, categoryName) => {
    try {
        const response = await axios.post (
            `api/category/add/${categoryName}`,
            {},
            { 
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
    
            }
        )
        return response
    } 
    catch (error) {
        if (error.response) {
            console.log("Add Category: ", error.response ? error.response.data : error.message)
            return error.response;
        }
    }
}

export const updateCategory = async (token, category) => {
    try {
        const response = await axios.post(
            "api/category/update",
            {
                categoryID: category.id, 
                name: category.name
            },
            
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response
    } 
    catch (error) {
        console.log("Update Category: ", error.response ? error.response.data : error.message)
    }
}

export const deleteCategory = async (token, categoryID) => {
    try {
        const response = await axios.post(
            `api/category/hide/${categoryID}`,
            {},
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }

        )

        return response
    } 
    catch (error) {
        console.log("Delete Category: ", error.response ? error.response.data : error.message)    
    }
}

export const getHiddenCategories = async (token) => {
    try {
        const response = await axios.get(
            "api/categories/is-hidden",
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("Hidden categories: ", error.response ? error.response.data : error.message)   
    }
}

export const getUnhiddenCategories = async (token) => {
    try {
        const response = await axios.get(
            "api/categories/is-displayed",
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getUnhiddenCategories ", error.response ? error.response.data : error.message)   
    }
}

export const unhideCategory = async (token, categoryID) => {
    try {
        const response = await axios.get(
            `api/category/unhide/${categoryID}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response
    } 
    catch (error) {
        console.log("Unhide Category: ", error.response ? error.response.data : error.message)    
    }
}

export const getTop5BestSellerCate = async (token) => {
    try {
        const response = await axios.get(
            `api/category/top-5`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        )
        return response.data
    } 
    catch (error) {
        console.log("getTop5BestSellerCate", error.response ? error.response.data : error.message)
    }
}